import { createContext } from "react";

const ExtraActMonthContext = createContext();

export default ExtraActMonthContext;